import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviceStatusMessageComponent } from './device-status-message/device-status-message.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    DeviceStatusMessageComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    DeviceStatusMessageComponent,
    TranslateModule // Re-export TranslateModule
  ]
})
export class SharedModule { }
